"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileFollowArtistButtonQueryRenderer = exports.MobileFollowArtistButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRelay = require("react-relay");

var _SystemContext = require("../../Artsy/SystemContext");

var _palette = require("@artsy/palette");

var _FollowArtistButton = require("./FollowArtistButton");

var _cohesion = require("@artsy/cohesion");

var _MobileFollowArtistButtonQuery;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileFollowArtistButton = function MobileFollowArtistButton(props) {
  return _react.default.createElement(_FollowArtistButton.FollowArtistButtonFragmentContainer, {
    contextModule: _cohesion.ContextModule.articleArtist,
    artist: props.artist
  });
};

exports.MobileFollowArtistButton = MobileFollowArtistButton;
var MobileFollowArtistButtonQueryRenderer = (0, _SystemContext.withSystemContext)(function (_ref) {
  var artistId = _ref.artistId,
      relayEnvironment = _ref.relayEnvironment;
  return _react.default.createElement(_reactRelay.QueryRenderer, {
    // @ts-ignore
    environment: relayEnvironment,
    query: _MobileFollowArtistButtonQuery !== void 0 ? _MobileFollowArtistButtonQuery : (_MobileFollowArtistButtonQuery = require("../../__generated__/MobileFollowArtistButtonQuery.graphql"), _MobileFollowArtistButtonQuery.hash && _MobileFollowArtistButtonQuery.hash !== "e249ef453f7f1400e7405137c158d6c1" && console.error("The definition of 'MobileFollowArtistButtonQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _MobileFollowArtistButtonQuery),
    variables: {
      artistId: artistId
    },
    render: function render(_ref2) {
      var props = _ref2.props;

      if (props) {
        return _react.default.createElement(MobileFollowArtistButton, props);
      } else {
        return _react.default.createElement(_palette.Flex, {
          position: "relative",
          height: "178px"
        }, _react.default.createElement(_palette.Spinner, null));
      }
    }
  });
});
exports.MobileFollowArtistButtonQueryRenderer = MobileFollowArtistButtonQueryRenderer;
//# sourceMappingURL=MobileFollowArtistButton.js.map